<template>
  <div class="upload-file" v-if="isShow">
      <el-upload
        :action="action"
        :before-upload="handleBeforeUpload"
        :limit="30"
        :multiple='multiple'
        :accept="accept"
        :on-error="handleUploadError"
        :on-exceed="handleExceed"
        :on-success="handleUploadSuccess"
        :http-request="httpRequest"
        :show-file-list="false"
        :auto-upload="true"
        :on-change="handleChange"
        class="upload-file-uploader"
        ref="upload"
        style="float:left;"
      >
        <el-button plain type="primary" plainicon="el-icon-plus" size="mini" :disabled="btnChangeEnable">+ 上传附件</el-button>
        <!-- 上传提示 -->
        <div class="el-upload__tip" slot="tip" v-if="isShowTip" style="float:right;margin-left: 10px;margin-top:0">
          请上传
          <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
          <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
          的文件
        </div>
      </el-upload>
    </div>

</template>

<script>
// import util from '../commonJs/http'
// import config from '../../public/config'
export default {
  data() {
    return {
      // 可上传的文件类型
      accept: '',
      action: 'action',
      fileCount:0
    };
  },
  props: {
    btnChangeEnable:{
      type: Boolean,
      default: false
    },
    // 值
    value: [String, Object, Array],
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 500,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => [],
    },
    // 是否可以多选
    multiple:{
      type: Boolean,
      default: false
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: false
    },
    // 附件所属ID
    objectID: {
      type: String
    },
    DispatchTime:{
      type: String,
      default:''
    },
    // 使用类型 0:普通附件,1:标题图片，2:富文本编辑器中的图片，可自行扩展
    UseType: {
      type: Number,
      default: 0
    },
    // 最多可上传多少个附件，0为不限制
    MaxFileNum: {
      type: Number,
      default: 0
    },
    TableName:{
      type:String,
      default:''
    },
    // 是否显示上传附件
    isShow: {
      type: Boolean,
      default: true
    },
  },

methods: {
    handleChange(file, fileList) {
      this.fileCount = fileList.length;
    },
    // 上传前校检格式、大小、数量
    handleBeforeUpload(file) {
      var fileLen=$('.useType'+this.UseType+' .imgd').length;
      if(this.MaxFileNum>0 && fileLen>=this.MaxFileNum){
        this.$message.error('最多可上传'+this.MaxFileNum+'个文件!');
        return false;
      }
      // 校检文件类型
      if (this.fileType.length>0) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf("."));
        }
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`);
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },
    // 文件个数超出
    handleExceed(files, fileList) {
      this.$message.error(`一次最多允许上传30个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error(err);
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      this.$message.success("上传成功");
    },
    /** 调用接口上传 */
    httpRequest(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      let that = this;
      //如果是课件上传-为避免上传文件过大 上传较慢时，将上传按钮设置为禁用，防止操作员重复点击上传按钮
      if (this.UseType === 0 && this.TableName === 't_base_course') {
        that.btnChangeEnable = true;
      }
        that.$api.post(process.env.VUE_APP_FileAddress + "Main/addFile?appID=" + process.env.VUE_APP_FileSysID
            + "&fileSystemKey=" + process.env.VUE_APP_FileSysToken+"&typeID=0&objectID="+this.objectID
      +"&useType="+this.UseType+"&tableName="+this.TableName+"&dispatchTime="+this.DispatchTime,
        formData,
        function (res) {
          if(res.code =='200'){
            param.onSuccess()
            that.btnChangeEnable = false;
            that.$emit("input",res.code)// 回调方法，文件上传成功后，会调用`input`指定的方法，在调用方定义
          }else{
            that.btnChangeEnable = false;
            param.onError('"'+param.file.name +'"，'+ res.msg)
          }
          // 自定义上传时，需自己执行成功回调函数
          that.$refs.upload.clearFiles()
        },
        function () {}
      );
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-upload-list {
  display: inline-block;
}
/deep/.el-upload-list__item:first-child {
  margin-top: 0;
}
.my-form-item {
  .el-form-item__content > div {
    display: flex;
    align-items: center;
  }
}
.att-manager {
  width: 100%;
  height: 100%;
}
.att-content {
  display: flex;
  flex-direction: column;
}
.att-add {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
}
.att-list {
  height: calc(100% - 50px);
  width: 100%;
}
.hideImgDiv {
  /deep/ .el-image__inner {
    display: none;
  }

  /deep/ .el-image__error {
    display: none;
  }
}
</style>
